import type { TuFunction } from "@src/appV2/i18n/types";

import { type MoreMenuItem } from "../../../MyProfessionals/components/ProfessionalMoreMenu";

/**
 * Lock status used to label the Lock/Unlock menu item, mirroring `InHomeLockToggle`'s
 * three branches: unlocked → "Lock", locked by current workplace → "Unlock",
 * locked by another workplace → "Locked".
 */
export type ChatLockStatus = "unlocked" | "lockedByCurrentWorkplace" | "lockedByOther";

interface GetChatActionMenuItemsParams {
  isStarred: boolean;
  isStarToggling: boolean;
  showStar: boolean;
  showCancel: boolean;
  showMarkUnread: boolean;
  showLock: boolean;
  lockStatus: ChatLockStatus;
  onToggleStar: () => void;
  onCancel: () => void;
  onMarkConversationAsUnread: () => void;
  onLock: () => void;
  tu: TuFunction;
}

export function getChatActionMenuItems(params: GetChatActionMenuItemsParams): MoreMenuItem[] {
  const {
    isStarred,
    isStarToggling,
    showStar,
    showCancel,
    showMarkUnread,
    showLock,
    lockStatus,
    onToggleStar,
    onCancel,
    onMarkConversationAsUnread,
    onLock,
    tu,
  } = params;

  const lockLabels: Record<ChatLockStatus, string> = {
    unlocked: tu("Lock"),
    lockedByCurrentWorkplace: tu("Unlock"),
    lockedByOther: tu("Locked"),
  };

  return [
    {
      label: isStarred ? tu("Remove from starred") : tu("Add to starred"),
      onClick: onToggleStar,
      visible: showStar,
      disabled: isStarToggling,
    },
    {
      label: tu("Worker asked me to cancel"),
      onClick: onCancel,
      visible: showCancel,
    },
    {
      label: lockLabels[lockStatus],
      onClick: onLock,
      visible: showLock,
    },
    {
      label: tu("Mark conversation as unread"),
      onClick: onMarkConversationAsUnread,
      visible: showMarkUnread,
    },
  ];
}
